import axios from "@/axios.js"

export default {
  searchClientUser({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/client_users/search_client_user/" + item)
        .then((response) => {
          commit('SET_CLIENT_USER', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchClientAndClientUser({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/client_users/search_client_and_client_user/" + item)
        .then((response) => {
          commit('SET_CLIENT_USER', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPrimaryContacts(context, data) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/client_users/client/${data.client_id}/search/${data.search}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getClientManagers({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/client_users/get_client_managers`, {item:item})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchAutocomplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/client_users/search/" + item)
        .then((response) => {
          // // console.log(response)
          commit('SET_AUTOCOMPLETE_DATA', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateClientUser({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/client_users/update_client_user", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('EDIT_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addClientUser({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/client_users/add_client_users", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getClientRoleTypes({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/client_users/get_client_role_types")
        .then((response) => {
          // // console.log(response)
          commit('SET_CLIENT_ROLE_TYPES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllClientUsers({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.get("/api/client_users/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          commit('SET_CLIENT_USERS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllClientUsersWithFilter({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/client_users/client_users_with_filter", {
          item: item
        })
        .then((response) => {
          commit('SET_CLIENT_USERS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getClientUserStatus({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/client_users/get_client_user_status")
        .then((response) => {
          // // console.log(response)
          commit('SET_CLIENT_USER_STATUS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchClientUser({
    commit
  }, clientUserId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/client_users/${clientUserId}`)
        .then((response) => {
          commit('SET_CLIENT_USER', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchStatus(context, statusId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/client_users/status/${statusId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
    fetchClientUserList({
      commit
    },item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/client_users/${item}`)
        .then((response) => {
          commit('SELECTED_ACCOUNT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeClientUser({
    commit
  }, clientUserId) {
    return new Promise((resolve, reject) => {
      // alert(clientUserId)
      axios.delete(`/api/client_users/${clientUserId}`)
        .then((response) => {
          commit('REMOVE_ACCOUNT', clientUserId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllClientContacts(context, data) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/client_users/client/${data.client_id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
